/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Ws_NInputs */

const en_mk_tut_ws_n = /** @type {(inputs: Mk_Tut_Ws_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One person can have several workspaces — one for the company and one to experiment in, say. Switch between them from the picker at the top left.`)
};

const id_mk_tut_ws_n = /** @type {(inputs: Mk_Tut_Ws_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu orang boleh punya beberapa workspace — misalnya satu untuk perusahaan dan satu untuk uji coba. Berpindah lewat pemilih di kiri atas.`)
};

/**
* | output |
* | --- |
* | "One person can have several workspaces — one for the company and one to experiment in, say. Switch between them from the picker at the top left." |
*
* @param {Mk_Tut_Ws_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_ws_n = /** @type {((inputs?: Mk_Tut_Ws_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Ws_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_ws_n(inputs)
	return en_mk_tut_ws_n(inputs)
});